export const CONSTANTS = {
  barrel: 'Бочка',
  AddFuel: 'Поповнення',
};
